
define('unknown/models/pwResetModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var PwReset = Backbone.Model.extend({
		urlRoot:"/draftapp/users/pwreset",
		//idAttribute: 'userName',
		defaults: {
	    	userName: null
	    },

	    initialize: function() {
	    	
	    },
	});
	
	
	return PwReset;  
});